import React from 'react';
import { useDispatch } from 'react-redux';
import { useInRouterContext, useNavigate } from 'react-router-dom';
import cn from 'classnames';
import { setSearchTerm } from '@repo/redux/actions/search';
import { Section, SectionTitle } from '@repo/components/containers';
import Contact from '@repo/utils/models/Contact';
import styles from './ContactInterests.module.scss';

const ClickableInterestsList = ({ contact }: { contact: Contact }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const searchForInterest = (interest: string, e: MouseEvent) => {
    e.preventDefault();
    dispatch(setSearchTerm(interest.toLowerCase(), true));
    navigate('/search');
  };

  return (
    <>
      {contact.interests.map((interest, i) => (
        <a
          href="#"
          onClick={searchForInterest.bind(null, interest.n)}
          className={cn(styles.interest)}
          key={i}
        >
          {interest.n}
        </a>
      ))}
    </>
  );
};

const InterestsList = ({ contact }: { contact: Contact }) => {
  return (
    <>
      {contact.interests.map((interest, i) => (
        <span className={cn(styles.interest, styles.notClickable)} key={i}>
          {interest.n}
        </span>
      ))}
    </>
  );
};

export function ContactInterests({
  contact,
  clickable = true,
  underline = true,
}: {
  contact: Contact;
  clickable?: boolean;
  underline?: boolean;
}) {
  const isInRouter = useInRouterContext();

  if (!contact.interests || contact.interests.length === 0) {
    return null;
  }

  return (
    <Section>
      <SectionTitle underline={underline}>Interests</SectionTitle>
      <div className={styles.container}>
        {clickable && isInRouter ? (
          <ClickableInterestsList contact={contact} />
        ) : (
          <InterestsList contact={contact} />
        )}
      </div>
    </Section>
  );
}
